import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { PartInventoryImageDetails } from "../../services/PartsInventory";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";

const PartsInvenPhoto = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { uuid } = useParams();

  const [vehicleImageDetails, setVehicleImageDetails] = useState([]);

  useEffect(
    function () {
      if (uuid) {
        var obj = {
          id: uuid,
        };
        PartInventoryImageDetails(obj)
          .then((response) => {
            response = response.data.data;
            setVehicleImageDetails(response);
          })
          .catch((err) => {});
      }
    },

    [uuid]
  );

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">{/* <h1>Vehicle</h1> */}</div>
              <div className="col-sm-6"></div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="container-fluid">
            <div className="card fuelCard">
              <div className="cardHeader card-header card-header-custom">
                <div className="row mb-2">
                  <div className="col-sm-6">
                    <p>{t("pi_part_pictures")}</p>
                  </div>
                  <div className="col-sm-6">
                    <div className="d-flex  justify-content-end">
                      <button
                        type="button"
                        className="next-button btn btn-secondary"
                        onClick={() => navigate("/parts-inventory")}
                      >
                        <i className="bi bi-arrow-left"></i> {t("back")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-body">
                <div className="vehicleThBg table-responsive table-responsive-vehicle">
                  <div className="col-md-12">
                    <div className="row">
                      <PhotoProvider>
                        {vehicleImageDetails &&
                        vehicleImageDetails?.length > 0 ? (
                          vehicleImageDetails?.map((item, index) => (
                            <React.Fragment key={index}>
                              <div className="col-md-4">
                                {item?.image_url ? (
                                  <PhotoView src={item.image_url}>
                                    <img
                                      src={item.image_url}
                                      alt="vehicle"
                                      style={{
                                        width: "60%",
                                        cursor: "pointer",
                                      }}
                                    />
                                  </PhotoView>
                                ) : (
                                  <p>{t("pi_no_image_found")}</p>
                                )}
                              </div>
                            </React.Fragment>
                          ))
                        ) : (
                          <p>{t("pi_no_image_found")}</p>
                        )}
                      </PhotoProvider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default PartsInvenPhoto;
